module.exports = __webpack_public_path__ + "static/media/close.dc90a13e.svg";